import { render, staticRenderFns } from "./FinalMarksCountReport.vue?vue&type=template&id=46b64388&"
import script from "./FinalMarksCountReport.vue?vue&type=script&lang=js&"
export * from "./FinalMarksCountReport.vue?vue&type=script&lang=js&"
import style0 from "./FinalMarksCountReport.vue?vue&type=style&index=0&id=46b64388&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports